export enum ProposalStatus {
    DRAFT = 'draft',
    ARCHIVED = 'archived',
    AWAITING = 'awaiting',
    ACCEPTED = 'accepted',
    REJECTED = 'rejected',
    PRODUCTS_USED_NOT_OFFERED = 'products_used_not_offered'
}

// Statuses whose proposals can still be edited (products/prices added or removed).
export const EDITABLE_STATUSES: ProposalStatus[] = [
    ProposalStatus.DRAFT,
    ProposalStatus.PRODUCTS_USED_NOT_OFFERED
];

export function isEditableStatus(status: string | undefined | null): boolean {
    return !!status && EDITABLE_STATUSES.includes(status.toLowerCase() as ProposalStatus);
}